import colors from '@/style/colors'

import hk from '../config/hk'

export const DEFAULT_NAME = 'React template'

export const pageStyle = `
  @page {
    size: A4;
    margin: 10mm;
  }

  @media print {
    body {
      zoom: 65%;
    }
  }
`

export const landscapePageStyle = `
  @page {
    size: landscape;
    margin: 10mm;
  }

  @media print {
    body {
      zoom: 65%;
    }
  }
`

export const dataColors = [
  colors.data1,
  colors.data2,
  colors.data3,
  colors.data4,
  colors.data5,
  colors.data6,
  colors.data7,
  colors.data8,
  colors.data9,
]

export const bannerImage = {
  cocaCola: {
    x1200: 'https://img.dimorder.com/1200x/public/dimsupply/600x180_DimFood.jpg',
    x2048: 'https://img.dimorder.com/2048x/public/dimsupply/1024x100_DimFood.jpg',
  },
}

export const adPopImage = {
  hk: 'https://img.dimorder.com/1140x/public/dimpay/1.png',
  th: '',
}

export const momentLocaleZH = {
  months: [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
  ],
  monthsShort: [
    '1月',
    '2月',
    '3月',
    '4月',
    '5月',
    '6月',
    '7月',
    '8月',
    '9月',
    '10月',
    '11月',
    '12月',
  ],
  weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  weekdaysShort: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
  weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'YYYY/MM/DD',
    LL: 'YYYY年M月D日',
    LLL: 'YYYY年M月D日 HH:mm',
    LLLL: 'YYYY年M月D日dddd HH:mm',
  },
  meridiem: (hour) => (hour < 12 ? '上午' : '下午'),
}

export const momentLocaleTH = {
  months: [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ],
  monthsShort: [
    'ม.ค.',
    'ก.พ.',
    'มี.ค.',
    'เม.ย.',
    'พ.ค.',
    'มิ.ย.',
    'ก.ค.',
    'ส.ค.',
    'ก.ย.',
    'ต.ค.',
    'พ.ย.',
    'ธ.ค.',
  ],
  weekdays: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
  weekdaysShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  weekdaysMin: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
  longDateFormat: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY เวลา H:mm',
    LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
  },
  meridiem: (hour) => (hour < 12 ? 'ก่อนเที่ยง' : 'หลังเที่ยง'),
}

export const FLOOR_PLAN = {
  10.2: {
    width: 740,
    height: 620,
  },
  11: {
    width: 840,
    height: 640,
  },
  12.9: {
    width: 1020,
    height: 840,
  },
  grid: 20,
  minTableSize: 76,
}

export const SHAPE = {
  SQUARE: 'square',
  RECTANGLE: 'rectangle',
  CIRCLE: 'circle',
  OVAL: 'oval',
}
